import { User } from './user.interface';
import { Identifiable } from './repository-params';
import { Settlement } from './settlement.interface';
import { marker as _ } from '@bling-fe/shared/utils';

/**
 * DailyReservableEntity in BE
 *
 */
export interface DailyReservable extends Identifiable {
  name: string;
  main_settlement: Settlement;
  events: DailyReservableEvent[];
  address: string;
  photos?: DailyReservablePhoto[];
  responsible_users: User[];
  entity_type: string;
  cleaning_costs_text: string;
  room_size?: string;
  infrastructure?: string;
  wlan?: string;
  towels?: string;
  reservation_info?: string;
  booking_hint_text?: string;
  cancellation_policy?: string;
  rental_duration?: string;
  price_text: string;
  dormakaba_enabled: boolean;
  payments_enabled: boolean;
  offline_payment_allowed: boolean;
  reservation_max_duration: number;
  reservation_min_duration: number;
  reservation_min_gap_between: number;
  reservation_days_in_advance: number;
  price: number;
  price_first_night: number;
  cleaning_costs: number;
  check_in: string;
  check_out: string;
  non_refundable_days_before: number;
  external_booking: boolean;
  homepage_url: string;
  email: string;
  payment_conditions: string;
  public_transportation: string;
  terms_and_conditions_enabled: boolean;
  specific_terms_and_conditions_key?: string;
  terms_and_conditions_body?: string;
  terms_and_conditions_file_url?: string;
  key_box_enabled: boolean;
}

export interface DailyReservableQueryParams {
  entity_type: DailyReservableType;
}

export interface DailyReservableEvent {
  start: string;
  end: string;
}

export interface DailyReservablePhoto {
  picture_url: string;
}

export type DailyReservableType = 'guestroom';

interface DailyReservableInfo {
  icon: string;
  title: string;
}

export const dailyReservableInfo = new Map<
  DailyReservableType,
  DailyReservableInfo
>([
  [
    'guestroom',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.GUEST_APARTMENT'),
      icon: 'house-line'
    }
  ]
]);
